import firebase from "firebase/app";

export const roleCollectionKey = "roles";

export type RoleType = "student" | "tutor" | "admin";

export type Role = {
  ref: firebase.firestore.DocumentReference;
  data: RoleData;
};

export type RoleData = {
  ref: firebase.firestore.DocumentReference;
  type: RoleType;
  isPrivateTutor?: boolean; // サーバーがスタッフ権限変更時に同期するアクセス制限用マーカー
  loginId?: string;
  code?: string;
  gmail?: string;
  microsoftEmail?: string;
};

export function convertToRole(
  data: firebase.firestore.DocumentData,
  ref: firebase.firestore.DocumentReference
): Role {
  const returnData: RoleData = {
    ref: data.ref,
    type: data.type
  };
  if (typeof data.isPrivateTutor === "boolean") {
    returnData.isPrivateTutor = data.isPrivateTutor;
  }
  if (data.loginId) {
    returnData.loginId = data.loginId;
  }
  if (data.code) {
    returnData.code = data.code;
  }
  if (data.gmail) {
    returnData.gmail = data.gmail;
  }
  if (data.microsoftEmail) {
    returnData.microsoftEmail = data.microsoftEmail;
  }

  return {
    ref,
    data: returnData
  };
}
